import axios from "axios";
import createAuthRefreshInterceptor from "axios-auth-refresh";
import { removeTokens, setTokens } from "../utils/localStorage";
import { getAccessToken, getDecodedTokenValue, refreshAccessToken } from "./auth";

const axiosInstance = axios.create({});


axiosInstance.interceptors.request.use(async (request) => {
  try {
    const token = await getAccessToken();
    // Anonymous requests carry no token. Never send an empty/guest header.
    if (token) {
      request.headers["Authorization"] = `Bearer ${token}`;
    }
    return request;
  } catch (e) {
    return request;
  }
});

const refreshAuthLogic = async (failedRequest) => {
  try {
    const refreshToken = localStorage.getItem("refreshToken");
    const decodedValue = await getDecodedTokenValue();
    const isGuest = decodedValue?.isGuest;

    // Guest sessions are no longer supported. If the stored token is a guest
    // (or there is no refresh token), do not attempt to refresh or re-mint —
    // drop the session and send the user to log in.
    if (isGuest || !refreshToken) {
      throw new Error("guest-or-missing-refresh-token");
    }

    const result = await refreshAccessToken({
      refresh_token: refreshToken
    });

    if (result && result.msg === "success") {
      setTokens(result.data.accessToken, result.data.refreshToken);
      failedRequest.response.config.headers["Authorization"] =
        "Bearer " + result.data.accessToken;
    } else {
      throw new Error(JSON.stringify(result));
    }
  } catch (e) {
    console.log("refresh user error - ", e);
    removeTokens();
    window.location = "/login";
  }
};

createAuthRefreshInterceptor(axiosInstance, refreshAuthLogic);


export default axiosInstance; 